export default "__VITE_ASSET__6ae09e79__"